import request from "@/utils/request";

// 新增用户为虚拟用户
export const addVirtualUserApi = (type, data) => {
  return request({
    url: "/user/saveOrUpdate?type=" + type,
    method: "post",
    data: data,
  });
};

//  修改帖子
export const saveOrUpdateApi = (data) => {
  return request({
    url: "/post/content/saveOrUpdate",
    method: "post",
    data: data,
  });
};

// 虚拟用户回复帖子或评论
export const saveVirtualReplyApi = (isCommentReply, data) => {
  return request({
    url: isCommentReply ? "/reply/comment/saveOrUpdate" : "/comment/saveOrUpdate",
    method: "post",
    data,
  });
};

// 置顶帖子
export const topPostApi = (contentId) => {
  return request({
    url: "/post/content/recommendation?contentId=" + contentId,
    method: "post"
  });
};

// 虚拟用户送礼
export const virUserSendGiftApi = (params) => {
  return request({
    url: `/user/give/gift/${params.giftId}/${params.userId}/${params.receiveUserId}`,
    method: "post",
  });
};

// 删除虚拟用户
export const removeVirtualUserApi = (id) => {
  return request({
    url: `/user/remove/${id}`,
    method: "delete",
  });
};

// 引导列表
export const getGuideListApi = (params) => {
  return request({
    url: `/guide/admin/list`,
    method: "get",
    params,
  });
};

// 新增或修改引导
export const setGuideSaveOrUpdateApi = (data) => {
  return request({
    url: `/guide/admin/saveOrUpdate`,
    method: "post",
    data,
  });
};

// 删除引导内容
export const deleteGuideApi = (id) => {
  return request({
    url: `/guide/admin/${id}`,
    method: "delete",
  });
};

// 根据用户ID查询任务记录
export const getTaskLogByUserIdApi = (userId, params) => {
  return request({
    url: `/system/taskLog/getByUserId/${userId}`,
    method: "get",
    params
  });
};

// 分页查询所有任务记录
export const getTaskLogApi = (params) => {
  return request({
    url: `/system/taskLog/page`,
    method: "get",
    params
  });
};

// 反馈内容列表
export const getFeedBackListApi = (params) => {
  return request({ url: `/feedback/page`, method: "get", params });
};

// 删除反馈内容
export const deleteFeedBackApi = (id) => {
  return request({
    url: `/feedback/delete?id=${id}`,
    method: "delete"
  });
};
